import { render, staticRenderFns } from "./ComplaintViewDetails.vue?vue&type=template&id=571fa2dc&scoped=true&"
import script from "./ComplaintViewDetails.vue?vue&type=script&lang=js&"
export * from "./ComplaintViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintViewDetails.vue?vue&type=style&index=0&id=571fa2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fa2dc",
  null
  
)

export default component.exports